import { GuideNavWeekCircle, GuideNavWeekCircles, GuideNavWeekProgress } from '@/components/custom/guide';
import React from 'react';

const cleanPercentage = percentage => {
  const isNegativeOrNaN = !Number.isFinite(+percentage) || percentage < 0; // we can set non-numbers to 0 here
  const isTooHigh = percentage > 100;

  return isNegativeOrNaN ? 0 : isTooHigh ? 100 : +percentage;
};

const Text = ({ text }) => {
  return (
    <text
      x="50%"
      y="50%"
    >
      {text}
    </text>
  );
};

export const StudyGuidePie = ({ value, text = '', colour, size, strokeWidth, strokeLineCap }) => {
  const percentage = cleanPercentage(value);

  return (
    <GuideNavWeekProgress>
      <GuideNavWeekCircles>
        <GuideNavWeekCircle
          size={size}
          strokeWidth={strokeWidth}
          strokeLineCap={strokeLineCap}
          className="stroke-bright"
        />
        <GuideNavWeekCircle
          colour={colour}
          percentage={percentage}
          size={size}
          strokeWidth={strokeWidth}
          strokeLineCap={strokeLineCap}
        />
      </GuideNavWeekCircles>

      <Text text={text} />
    </GuideNavWeekProgress>
  );
};
